import React from 'react'

import { ButtonClean, PriceString, Tag } from '@fourthwall/components'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'
import type { FromLocationState } from '@types'

import type { ChargesHistoryDataItem } from '../../Billing.types'
import { tagsAppearances } from '../../consts'
import { PaymentMethod } from '../PaymentMethod/PaymentMethod'
import * as S from './ChargesHistoryListItem.styled'

type ChargesHistoryListItemProps = {
  chargesHistoryItem: ChargesHistoryDataItem
  locationState: FromLocationState
}

export const ChargesHistoryListItem = ({
  chargesHistoryItem,
  locationState,
}: ChargesHistoryListItemProps) => {
  return (
    <S.Container>
      <S.LeftSide>
        <S.Date>
          <TimezonedDateString date={chargesHistoryItem.date} format="MMM DD, YYYY" />
        </S.Date>
        <ButtonClean
          to={chargesHistoryItem.type.url}
          label={chargesHistoryItem.type.label}
          state={locationState}
        />
        <S.TagWrapper>
          <Tag
            label={chargesHistoryItem.status}
            appearance={tagsAppearances[chargesHistoryItem.status]}
          />
        </S.TagWrapper>
      </S.LeftSide>
      <S.RightSide>
        <S.PriceWrapper>
          <PriceString
            value={chargesHistoryItem.amount.value}
            currency={chargesHistoryItem.amount.currency}
          />
        </S.PriceWrapper>
        <PaymentMethod method={chargesHistoryItem.method} />
      </S.RightSide>
    </S.Container>
  )
}
